// ponytail: single-render + JS reposition. The "below image" marker block wraps
// every block after it in .dd0-below-zone. On desktop (>=750px, 2-col grid) that
// one node jumps under the gallery; on mobile it stays in the info column. No
// Liquid duplication — a single node is repositioned instead of re-rendering 3x.
(function () {
  var mq = window.matchMedia('(min-width: 750px)');

  function place(zone) {
    var product = zone.closest('.product');
    var target = product && product.querySelector('[data-dd0-below-target]');
    var info = product && product.querySelector('.product__info-container');
    if (target && info) {
      if (mq.matches) {
        if (zone.parentElement !== target) target.appendChild(zone);
      } else if (zone.parentElement === target) {
        // insertBefore(..., null) appends to end when there's no view-details link
        info.insertBefore(zone, info.querySelector('.product__view-details'));
      }
    }
    // always reveal (defends the anti-flash hide from ever sticking)
    zone.classList.add('dd0-below-ready');
  }

  function run() {
    document.querySelectorAll('[data-dd0-below-zone]').forEach(place);
  }

  run();
  mq.addEventListener('change', run);
})();
